import { useId } from 'react';

export interface AdminSelectOption {
  value: string;
  label: string;
}

export interface AdminSelectProps {
  label: string;
  value: string;
  onChange: (value: string) => void;
  options: AdminSelectOption[];
  /** Rendered as the first, empty-value option -- e.g. "All statuses." */
  allLabel?: string;
}

/** A native `<select>` -- deliberately not a custom listbox: full keyboard/screen-reader support for free, no focus-trap or roving-tabindex code to get right for what is, in every use here, a short flat option list. */
export function AdminSelect({ label, value, onChange, options, allLabel }: AdminSelectProps) {
  const id = useId();
  return (
    <label htmlFor={id} className="flex items-center gap-1.5 text-sm text-gray-600">
      <span className="sr-only">{label}</span>
      <select
        id={id}
        value={value}
        onChange={(event) => onChange(event.target.value)}
        className="focus-visible:ring-brand rounded-full border border-gray-200 bg-white py-1.5 pl-3 pr-8 text-sm focus-visible:outline-none focus-visible:ring-2"
      >
        {allLabel && <option value="">{allLabel}</option>}
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </label>
  );
}
